import React, { useState } from "react";
import PropTypes from "prop-types";
import CompanyDetailsDisplay from "./companyDetailsDisplay";
import EditCompanyDetails from "./editCompanyDetails";
import useCompanyDetails from "./useCompanyDetails";
import { scrollIntoView } from "utils/helper";

function CompanyDetails({ isShowEditIcon = true }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { onEditSave, isLoading } = useCompanyDetails();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("companyDetailsSection");
  };

  const handleSave = async (values) => {
    await onEditSave(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditCompanyDetails
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <CompanyDetailsDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

CompanyDetails.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default CompanyDetails;